import React from 'react';
import {ProgressStepComponentProps} from './ProgressStepComponent';
import {ProgressStepLayout} from './ProgressStepLayout';

// Due to split/branching not really existing, we calculate the "completion" in a different way than other progress bar steps.
// We simply look if it is disabled, which is calculated in "SequencedFlowProgressBar" based on completion status of all sections in the branching scenario.
export const BranchingProgressStep: React.FC<ProgressStepComponentProps> = (props) => {
  const isClickable = props.onClick && !props.disabled && !props.selected;
  return <ProgressStepLayout {...props} isClickable={isClickable} isCompleted={!props.disabled} />;
};
